import * as yup from 'yup';
import type { TFunction } from 'i18next';
import { PATIENT_NAME_MAX_LENGTH } from '@/shared/constants/personFields';
import type {
  CreateCustomerSourcePayload,
  CustomerSource,
  UpdateCustomerSourcePayload,
} from '../api/customerSource.api';

export const CUSTOMER_SOURCE_NAME_MAX_LENGTH = PATIENT_NAME_MAX_LENGTH;

export interface CustomerSourceFormValues {
  name: string;
  sortOrder: number;
  isActive: boolean;
}

export const emptyCustomerSourceFormValues = (): CustomerSourceFormValues => ({
  name: '',
  sortOrder: 0,
  isActive: true,
});

export const customerSourceToFormValues = (source: CustomerSource): CustomerSourceFormValues => ({
  name: source.name,
  sortOrder: source.sortOrder ?? 0,
  isActive: source.isActive,
});

export const buildCustomerSourceFormSchema = (t: TFunction<'patient'>) =>
  yup.object({
    name: yup
      .string()
      .trim()
      .required(t('customerSourceCatalog.validation.nameRequired'))
      .max(CUSTOMER_SOURCE_NAME_MAX_LENGTH),
    sortOrder: yup
      .number()
      .typeError(t('customerSourceCatalog.validation.sortOrderInvalid'))
      .integer(t('customerSourceCatalog.validation.sortOrderInvalid'))
      .min(0, t('customerSourceCatalog.validation.sortOrderMin'))
      .required(),
    isActive: yup.boolean().required(),
  });

export const formValuesToCreatePayload = (
  values: CustomerSourceFormValues,
): CreateCustomerSourcePayload => ({
  name: values.name.trim(),
  sortOrder: values.sortOrder,
});

export const formValuesToUpdatePayload = (
  values: CustomerSourceFormValues,
): UpdateCustomerSourcePayload => ({
  name: values.name.trim(),
  sortOrder: values.sortOrder,
  isActive: values.isActive,
});
